import { ResponseType } from "../../../Types/ServicesType/servicesType";
import {
  AllDoctorsType,
  // AllTimeSlotPayloadType,
  BookingListType,
  DepartmentTypes,
  DoctorsType,
  // PatientFullDetailsType,
  SaveParamsType,
  SavePayloadType,
  BookingSaveResponse,
  TimeSlotPayloadType,
  TimeSlotType,
  DoctorWaitingListType,
  UpcomingReviewBookingType,
} from "./types";
// import { oldInstance } from "../../services/services";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId,createdById} = getConstants()
const { patientBookingApi } = api;

export type GetAllDoctorsBookingPayload = {
  clinicId: number;
  startDate:string;
  endDate:string;
  doctorId: null;
  search?:string | null
};
export type SlotDeletionPermanentPayload = {
  bookingId: number;
  permanentDelete: number;
  clinicId:number
  reason?:null | string
};

export type BackendDoctor = {
  doctorId: number;
  doctorName: string;
  color:string;
  
    departmentId?: number;
    departmentName?: string;
    visitType?:number
    durationForPatient?:number


};

export type BackendDoctorBooking = {
  doctorId: number;
  doctorName: string;
  departmentId: number;
  departmentName?:string;
  journeyStatus?:string;
  gmail:string;
  color: string;
  status: number;
  department: {
    departmentId: number;
    departmentName: string;
  };
  bookings: {
    id: number;
    patientName: string;
    mobile: string;
    appDate: string;
    start: string;
    end: string;
    timeSlotNo: number | null;
    tokenNo: number;
    status: number;
    isCompleted:string
  }[];

};

export type DoctorBookingResponse = {
  doctors: BackendDoctor[];
  doctorBookings: BackendDoctorBooking[];
};


export const getTimeSlotes = async (
  params: Omit<TimeSlotPayloadType, "clinicId">
): Promise<ResponseType<TimeSlotType[]>> => {
    const result = (
      await instance.post(patientBookingApi.getTimeSlot, {
        ...params,
        clinicId,
      })
    ).data;
    return result;
};

// export const getAllTimeSlotes = async (
//   params: Omit<AllTimeSlotPayloadType, "clinicId">
// ): Promise<ResponseType<TimeSlotType[]>> => {
//     const result = (
//       await instance.post(patientBookingApi.getAllTimeSlot, {
//         ...params,
//         clinicId,
//       })
//     ).data;
//     return result;
// };

export const getAllDoctors = async (clinicid:number | null | undefined): Promise<
  ResponseType<AllDoctorsType[]>
> => {

  const result = (
    await instance.get(`${patientBookingApi.alldoctors}${ clinicid ? clinicid : clinicId}`)
  ).data;
  return result;
};

export const getDoctorsByDepartment = async ({
  departmentId,
  selectedTime,
  dayId,
}: {
  departmentId: number;
  selectedTime?: string;
  dayId?: number;
}): Promise<ResponseType<DoctorsType[]>> => {
    const result = (
      await instance.post(`${patientBookingApi.getDoctorByDepartment}`, {
        clinicId,
        departmentId,
        selectedTime,
        dayId,
      })
    ).data;
    return result;
};

export const getAllDepattment = async (): Promise<
  ResponseType<DepartmentTypes[]>
> => {
    const result = (
      await instance.get(`${patientBookingApi.getAllDepartments}${clinicId}`)
    ).data;
    return result;
};

export const saveAppointmentsV2 = async ( params: SaveParamsType ): Promise<ResponseType<BookingSaveResponse | null>> => {
  const body: SavePayloadType = {
    ...params,
    clinicId,
    createdByUserId: createdById as number,
    ip: "",
    createdDate: "",
  };
if(params?.id){
  return (await instance.put(patientBookingApi.saveBookingv2, body))
    .data;
}else{
  return (await instance.post(patientBookingApi.saveBookingv2, body))
    .data;
}
};

export const getAllBookings = async ({
  startTime,
  endTime,
  departmentId = null,
  doctorId = null,
}: {
  startTime: string;
  endTime: string;
  departmentId: number | null;
  doctorId: number | null;
}): Promise<ResponseType<BookingListType>> => {
  const result = (
    await instance.post(patientBookingApi.getAllBookings, {
      departmentId,
      doctorId,
      startTime,
      endTime,
      clinicId,
    })
  ).data;
  return result;
};


export const getAllDoctorsBooking = async (
  payload: GetAllDoctorsBookingPayload
): Promise<ResponseType<DoctorBookingResponse>> => {
  return (await instance.post(
    patientBookingApi.getAllDoctorsBooking,
    payload
  )).data;
};


export const updateBookings = async (params: {
  bookingId: number;
  doctorId?: number;
  startBookingDate?: string;
  endBookingDate?: string;
  status?:number
}): Promise<ResponseType<string | null>> => {
  return (await instance.post(patientBookingApi.changeSlot,{...params,clinicId})).data;
};

// export const cancelBooking = async (  { id, reason }: { id: string; reason: string }): Promise<ResponseType<string|null>> => {
//   return await instance.delete(`${patientBookingApi.deleteBooking}${clinicId}?bookingId=${id}&reason=${reason}`,{

//   })
// };

export const cancelBookingPermanent = async (
  payload: SlotDeletionPermanentPayload
): Promise<ResponseType<string | null>> => {
  const response = await instance.delete(
    patientBookingApi.slotCompleteDeleteBooking,
    {
      data: payload,
    }
  );

  return response.data;
};



// export const getSearchedPatientByEMR = async (
//   emrno: string
// ): Promise<PatientFullDetailsType | null> => {
//   const body = { emrno, clinicId };
//   try {
//     const result = await oldInstance.post(
//       "/rcm/admin/patientreg/getPatientByEmr?access_token=" + user?.refreshtoken,
//       body
//     );
//     return result?.data;
//   } catch (error) {
//     return null;
//   }
// };

export const getRegisteredpatients = async (id:number) => {
  console.log(id);
  return [];
};

export const getPatientById = async (id: any) => {
  console.log(id);

  try {
  } catch (error) {
    return {};
  }
};
export const changeQueuestatus = async ({ id, status }: any) => {
  console.log(id, status);

  try {
    //Success
  } catch (error) {
    return "Something went wrong";
  }
};

export const getDoctorsWaitingList = async (
  doctorId: number,
): Promise<ResponseType<DoctorWaitingListType>> => {
  const result = (
    await instance.get(`${patientBookingApi.doctorsWaitingList}${doctorId}`)
  ).data;
  return result;
};

export const getBookingWithReviewDate = async (): Promise<
  ResponseType<UpcomingReviewBookingType[]>
> => {
  const result = (
    await instance.get(patientBookingApi.getBookingWithReviewDate)
  ).data;
  return result;
};
